export default __webpack_public_path__ + "static/media/audioamplifier.577cb100.svg";